import React from 'react';
import {
  Box,
} from '@mui/material';
import ReactQuill from 'react-quill-new';
import 'react-quill-new/dist/quill.snow.css';
import { wikiTheme } from '../wikiTheme';

/**
 * Reusable component for editing wiki entry descriptions with rich text
 */
const RichTextEditor = ({ value, onChange, placeholder = 'Enter description...' }) => {
  const modules = {
    toolbar: [
      [{ header: [1, 2, 3, false] }],
      ['bold', 'italic', 'underline', 'strike'],
      ['blockquote', 'code-block'],
      [{ list: 'ordered' }, { list: 'bullet' }],
      ['link', 'image'],
      ['clean'],
    ],
  };

  const formats = [
    'header',
    'bold',
    'italic',
    'underline',
    'strike',
    'blockquote',
    'code-block',
    'list',
    'bullet',
    'link',
    'image',
  ];

  return (
    <Box 
      sx={{ 
        '& .ql-container': { 
          minHeight: '300px',
          backgroundColor: wikiTheme.mediumGray,
          color: wikiTheme.secondary,
          fontFamily: wikiTheme.font,
          fontSize: '1rem',
        },
        '& .ql-editor': {
          color: wikiTheme.secondary,
          fontFamily: wikiTheme.font,
        },
        '& .ql-toolbar': {
          backgroundColor: wikiTheme.lightGray,
          borderColor: wikiTheme.primary,
          borderTop: `2px solid ${wikiTheme.primary}`,
        },
        '& .ql-stroke': {
          stroke: wikiTheme.primary,
        },
        '& .ql-fill': {
          fill: wikiTheme.primary,
        },
        '& .ql-picker-label': {
          color: wikiTheme.tertiary,
        },
        '& .ql-toolbar.ql-snow .ql-picker-label:hover': {
          color: wikiTheme.primary,
        },
        '& .ql-toolbar.ql-snow .ql-picker-item:hover': {
          color: wikiTheme.primary,
        },
        '& .ql-toolbar.ql-snow button:hover': {
          color: wikiTheme.primary,
        },
        '& .ql-toolbar.ql-snow button.ql-active': {
          color: wikiTheme.primary,
        },
      }}
    >
      <ReactQuill
        value={value}
        onChange={onChange}
        modules={modules}
        formats={formats}
        placeholder={placeholder}
        theme="snow"
      />
    </Box>
  );
};

export default RichTextEditor;
